export function getMonthOptions(selectedYear) {
  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  return monthNames.map((name, index) => {
    const monthNumber = (index + 1).toString().padStart(2, "0");
    const firstDay = `${selectedYear}-${monthNumber}-01T00:00:00.000Z`;

    const lastDayDate = new Date(selectedYear, index + 1, 0);
    const lastDay = `${selectedYear}-${(lastDayDate.getMonth() + 1)
      .toString()
      .padStart(2, "0")}-${lastDayDate
      .getDate()
      .toString()
      .padStart(2, "0")}T23:59:59.999Z`;

    return {
      name,
      createdAt: {
        $gte: firstDay,
        $lte: lastDay,
      },
    };
  });
}
